import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  dialogTitle: {
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  dialogContent: {
    pb: 2,
  },
  columnContainer: {
    display: "flex",
    gap: 1,
    py: 1,
    borderTop: "1px solid #e0e0e0",
    borderBottom: "1px solid #e0e0e0",
    overflowX: "auto",
    whiteSpace: "nowrap",
    mt: 2,
    mb: 4,
  },
  chip: {
    height: "40px",
    fontSize: "0.875rem",
    borderColor: "grey.300",
    borderRadius: 1,
    flexShrink: 0,
    "& .MuiChip-label": {
      px: 2,
    },
  },
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  },
};

const ColumnLayoutPreviewModal = ({ open, onClose, columnTags }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        <Typography align="center" color="text.primary" fontWeight={500} fontSize={18}>
          Current Column Order
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        {columnTags.length > 0 ? (
          <Box sx={styles.columnContainer}>
            {columnTags.map((tag, index) => (
              <Chip
                key={tag.id}
                label={tag.content}
                variant="outlined"
                sx={styles.chip}
              />
            ))}
          </Box>
        ) : (
          <Box sx={styles.emptyState}>
            <Typography variant="body1" color="textSecondary">
              No columns selected
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ColumnLayoutPreviewModal;
